import React from 'react';
import { SectionHeader } from '@apps/components/section-header';
import Image from 'next/image';

const Services = ({title, subTitle, servicesData}) => {
	return (
		<div>
			{/* <!-- Services --> */}
			<section className="py-24 dark:bg-[#101436]">
				<div className="container">
					<div className="mx-auto mb-12 text-center">
            <SectionHeader title={title} subTitle={subTitle}/>
					</div>
					<div className="grid grid-cols-12 gap-8">
						{servicesData?.map((item) => {
							const { id, icon, title, desc, itemClass } = item;
							return (
								<div
									key={id}
									className={`${itemClass} service-item relative rounded-2.5xl border border-jacarta-100 bg-white p-10 pt-12 transition-shadow hover:shadow-xl dark:border-jacarta-700 dark:bg-[#131740]`}
								>
                  <Image src={icon} alt="" height={48} width={48} />
									<h3 className="mt-[25px] mb-4 font-display text-lg text-jacarta-700 dark:text-white">
										{title}
									</h3>
									<p className="dark:text-jacarta-300">{desc}</p>
								</div>
							);
						})}
					</div>
				</div>
			</section>
			{/* <!-- end services --> */}
		</div>
	);
};

export default Services;
